import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  IBatchConfig,
  IBatchConfigForm
} from './../../../../models/batch-config';
import { ICustomSelect } from './../../../../models/generic';

@Component({
  selector: 'app-header-repasse',
  templateUrl: './header-repasse.component.html',
  styleUrls: ['./header-repasse.component.scss']
})
export class HeaderRepasseComponent implements OnInit {
  @Input() bankOpts: ICustomSelect[] = [];
  @Input() channelOpts: ICustomSelect[] = [];

  @Output() addConfigEvent = new EventEmitter<IBatchConfig>();

  form!: FormGroup<IBatchConfigForm>;

  constructor() {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.form = new FormGroup<IBatchConfigForm>({
      Bank: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      Channel: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
  }

  addConfig(): void {
    const batchConfig = this.form.getRawValue() as IBatchConfig;
    this.addConfigEvent.emit(batchConfig);
    this.form.reset();
  }
}
